import { render } from "./TopTenPro.vue?vue&type=template&id=8a29fb7e&scoped=true"
import script from "./TopTenPro.vue?vue&type=script&lang=js"
export * from "./TopTenPro.vue?vue&type=script&lang=js"

import "./TopTenPro.vue?vue&type=style&index=0&id=8a29fb7e&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a29fb7e"]])

export default __exports__